const doc = [({"zh_cn":({"adminConstantHotelQuestionApplicableConditionType":({"all":"全部", "specifiedPlans":"指定方案"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;